<template>
  <v-navigation-drawer
    v-model="expanded"
    app
    clipped
    permanent
    :mini-variant.sync="mini"
    @click.native.stop
  >
    <v-list
      dense
      class="pt-0"
    >
      <v-list-item-group>
        <v-list-item
          @click="mini = !mini"
        >
          <v-list-item-icon
            class="center-icon"
            link
          >
            <v-icon> fa-bars </v-icon>
          </v-list-item-icon>
          <v-list-item-title />
        </v-list-item>
        <div
          v-for="route in filteredRoutes"
          :key="route.path"
        >
          <v-divider v-if="route.routeNames.includes($routeNames.ADMIN_PLAYERS)" />
          <v-list-item
            v-if="!route.children"
            link
            :to="{ name: route.routeNames[0]}"
            active-class="list-item-active"
          >
            <v-list-item-icon class="center-icon">
              <img
                :src="route.icon"
                alt=""
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ route.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else
            :value="route.routeNames.includes($route.name)"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon class="center-icon">
                <img
                  :src="route.icon"
                  alt=""
                >
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ route.name }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="child in route.children"
              :key="child.path"
              :to="child.view ? { name: child.routeName, query: { view: child.view }} : { name: child.routeName } "
              exact
            >
              <v-list-item-title>{{ child.name }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-divider v-if="route.routeNames.includes($routeNames.EVENTS)" />
        </div>
      </v-list-item-group>
    </v-list>
    <template
      v-if="!hasNoPlayers"
      v-slot:append
    >
      <div class="pa-3">
        <team-select-menu :mini="mini" />
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script>
import admin from '@/assets/img/sidebar/Admin.svg'
import calendar from '@/assets/img/sidebar/Calendar.svg'
import diagnostics from '@/assets/img/sidebar/Diagnostics.svg'
import mainDashboard from '@/assets/img/sidebar/Main Dashboard.svg'
import medical from '@/assets/img/sidebar/Medical.svg'
import membership from '@/assets/img/sidebar/Membership.svg'
import performance from '@/assets/img/sidebar/Performance.svg'
import trainingLoad from '@/assets/img/sidebar/Training Load.svg'
import trainingPrograms from '@/assets/img/sidebar/Training Programs.svg'
import trainingProtocols from '@/assets/img/sidebar/Trianing Protocols.svg'
import drill from '@/assets/img/sidebar/UX Drill.svg'
import wellness from '@/assets/img/sidebar/Wellness.svg'
import dailyActivity from '@/assets/img/sidebar/DailyActivity.svg'
import scouting from '@/assets/img/sidebar/Scouting.svg'
import mediaLibrary from '@/assets/img/sidebar/MediaLibrary.svg'
import competition from '@/assets/img/sidebar/Competition.svg'
import TeamSelectMenu from '@/components/TeamSelectMenu.vue'
import { TrainingExerciseApiService } from '@/data/services/TrainingExerciseApiService'
import { toCamelCase } from '@/utils/helpers'

export default {
  name: 'SideBar',
  components: { TeamSelectMenu },
  data() {
    return {
      expanded: true,
      mini: false,
      trainingGroups: {
        loading: false,
        data: []
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    currentTeam() {
      return this.$store.getters[this.$storeGetters.APP_CURRENT_TEAM]
    },
    routes() {
      return [
        {
          routeNames: [this.$routeNames.OVERVIEW, this.$routeNames.DASHBOARD_PLAYERS, this.$routeNames.LINEUPS],
          name: this.$t('sidebar.main_dashboard.label'),
          children: [
            { routeName: this.$routeNames.OVERVIEW, name: this.$t('sidebar.main_dashboard.overview.label'), active: this.hasItlModule || this.hasGpsModule || this.hasHrModule },
            { routeName: this.$routeNames.DASHBOARD_PLAYERS, name: this.$t('sidebar.main_dashboard.players_list.label'), active: true },
            { routeName: this.$routeNames.LINEUPS, name: this.$t('sidebar.main_dashboard.lineups.label'), active: ['Football', 'Handball', 'Basketball'].includes(this.currentTeam?.sport?.name) }],
          active: !this.hasNoPlayers,
          icon: mainDashboard
        },
        {
          routeNames: [this.$routeNames.EVENTS],
          name: this.$t('sidebar.calendar.label'),
          children: null,
          active: !this.hasNoEvents,
          icon: calendar
        },
        {
          routeNames: [this.$routeNames.MEDIA_LIBRARY],
          name: this.$t('sidebar.media_library.label'),
          children: null,
          active: true,
          icon: mediaLibrary
        },
        ...(this.$can('view-training-protocols') ? [{
          routeNames: [this.$routeNames.TRAINING_PROTOCOLS, this.$routeNames.TRAINING_EXERCISES, this.$routeNames.SESSIONS_OVERVIEW],
          name: this.$t('sidebar.training_protocols.label'),
          children: [
            { routeName: this.$routeNames.SESSIONS_OVERVIEW, name: this.$t('sidebar.sessions_overview.label'), active: true },
            { routeName: this.$routeNames.TRAINING_PROTOCOLS, name: this.$t('sidebar.training_protocols.your_protocols.label'), active: true },
            ...this.trainingGroups.data.map(item => {
              return { routeName: this.$routeNames.TRAINING_EXERCISES, view: item.group_id, name: this.$t('sidebar.training_protocols.sport_specific.' + toCamelCase(item.name) + '.label'), active: true }
            }),
            { routeName: this.$routeNames.TRAINING_EXERCISES, name: this.$t('sidebar.training_protocols.SnC_library.label'), active: true }
          ],
          active: this.hasTrainingBuilderModule && !this.hasNoPlayers,
          icon: trainingProtocols
        }] : []),
        {
          routeNames: [this.$routeNames.DRILL_BUILDER],
          name: this.$t('sidebar.drill.label'),
          children: null,
          active: this.hasDrillModule && this.teamWithDrill,
          icon: drill
        },
        {
          routeNames: [this.$routeNames.COMPETITIONS],
          name: this.$t('sidebar.comet.label'),
          children: null,
          active: this.hasCometIntegration,
          icon: competition
        },
        ...(this.$can('view-diagnostics') ? [{
          routeNames: [this.$routeNames.DIAGNOSTICS, this.$routeNames.DIAGNOSTIC_PROTOCOLS, this.$routeNames.DIAGNOSTIC_COMPARISON],
          name: this.$t('sidebar.diagnostics.label'),
          children: [
            { routeName: this.$routeNames.DIAGNOSTIC_PROTOCOLS, name: this.$t('sidebar.diagnostics.your_protocols.label'), active: true },
            { routeName: this.$routeNames.DIAGNOSTICS, name: this.$t('sidebar.diagnostics.measurements_analysis.label'), active: true },
            { routeName: this.$routeNames.DIAGNOSTIC_COMPARISON, name: this.$t('sidebar.diagnostics.advanced_comparison.label'), active: true }
          ],
          active: this.hasDiagnosticsModule && !this.hasNoPlayers,
          icon: diagnostics
        }] : []),
        ...(this.$can('view-medical') ? [{
          routeNames: [this.$routeNames.MEDICAL],
          name: this.$t('sidebar.medical.label'),
          children: null,
          active: this.hasMedicalModule && !this.hasNoPlayers,
          icon: medical
        }] : []),
        ...(this.$can('view-performance') ? [{
          routeNames: [this.$routeNames.PERFORMANCE_EVENT, this.$routeNames.PERFORMANCE_ADVANCED, this.$routeNames.PERFORMANCE_WEEKLY_LOAD],
          name: this.$t('sidebar.performance.label'),
          children: [
            { routeName: this.$routeNames.PERFORMANCE_EVENT, name: this.$t('sidebar.performance.event_analysis.label'), active: true },
            { routeName: this.$routeNames.PERFORMANCE_WEEKLY_LOAD, name: this.$t('sidebar.performance.weekly_load_overview.label'), active: true },
            { routeName: this.$routeNames.PERFORMANCE_ADVANCED, name: this.$t('sidebar.performance.advanced_analysis.label'), active: true }
          ],
          active: (this.hasGpsModule || this.hasHrModule) && !this.hasNoPlayers,
          icon: performance
        }] : []),
        {
          routeNames: [this.$routeNames.WELLNESS],
          name: this.$t('sidebar.wellness.label'),
          children: null,
          active: !this.hasNoPlayers && this.hasItlModule,
          icon: wellness
        },
        {
          routeNames: [this.$routeNames.DAILY_ACTIVITY],
          name: this.$t('sidebar.daily_activity.label'),
          children: null,
          active: !this.hasNoPlayers && this.hasDailyActivityModule,
          icon: dailyActivity
        },
        {
          routeNames: [this.$routeNames.LOAD],
          name: this.$t('sidebar.load.label'),
          children: null,
          active: !this.hasNoPlayers && (this.hasItlModule || this.hasGpsModule || this.hasHrModule),
          icon: trainingLoad
        },
        {
          routeNames: [this.$routeNames.EVENT_STATS],
          name: this.$t('sidebar.treatment_analysis.label'),
          children: null,
          active: !this.hasNoPlayers && this.hasEventStats,
          icon: medical
        },
        {
          routeNames: [this.$routeNames.SCOUTING],
          name: this.$t('sidebar.scouting.label'),
          children: null,
          active: !this.hasNoPlayers && this.hasScoutingModule,
          icon: scouting
        },
        {
          routeNames: [this.$routeNames.TRAINING_PROGRAMS, this.$routeNames.TRAINING_PROGRAM_INSTANCES],
          name: this.$t('sidebar.training_programs.label'),
          children: [
            { routeName: this.$routeNames.TRAINING_PROGRAMS, name: this.$t('sidebar.training_programs.program_library.label'), active: true },
            { routeName: this.$routeNames.TRAINING_PROGRAM_INSTANCES, name: this.$t('sidebar.training_programs.active_programs.label'), active: true }
          ],
          active: this.hasTrainingProgramsModule && !this.hasNoPlayers,
          icon: trainingPrograms
        },
        ...(this.$can('view-membership') ? [{
          routeNames: [this.$routeNames.MEMBERSHIP_FEES],
          name: this.$t('sidebar.membership.label'),
          children: null,
          active: this.hasMembershipModule && !this.hasNoPlayers,
          icon: membership
        }] : []),
        {
          routeNames: [
            this.$routeNames.ADMIN_PLAYERS,
            this.$routeNames.ADMIN_TEAMS,
            this.$routeNames.ADMIN_STAFF,
            this.$routeNames.ADMIN_PARENTS,
            this.$routeNames.ADMIN_LOCATIONS,
            this.$routeNames.ADMIN_MEMBERSHIP_PLANS,
            this.$routeNames.ADMIN_DEVICES,
            this.$routeNames.ADMIN_POLAR_TEAM,
            this.$routeNames.ADMIN_GPEXE,
            this.$routeNames.ADMIN_FIELDWIZ,
            this.$routeNames.ADMIN_CATAPULT,
            this.$routeNames.ADMIN_VALD,
            this.$routeNames.ADMIN_KINEXON,
            this.$routeNames.ADMIN_COMET,
            this.$routeNames.ADMIN_STATSPORTS,
            this.$routeNames.ADMIN_QUESTIONNAIRES,
            this.$routeNames.ADMIN_BILLING
          ],
          name: this.$t('sidebar.admin.label'),
          children: [
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_PLAYERS, name: this.$t('sidebar.admin.players.label'), active: this.$can('manage-team-players') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_TEAMS, name: this.$t('sidebar.admin.teams.label'), active: this.$can('manage-organisation') }] : []),
            ...(!this.hasNoStaff ? [{ routeName: this.$routeNames.ADMIN_STAFF, name: this.$t('sidebar.admin.staff.label'), active: this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_PARENTS, name: this.$t('sidebar.admin.parents.label'), active: this.hasParentsModule && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoEvents ? [{ routeName: this.$routeNames.ADMIN_LOCATIONS, name: this.$t('sidebar.admin.locations.label'), active: this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_MEMBERSHIP_PLANS, name: this.$t('sidebar.admin.membership_plans.label'), active: this.hasMembershipModule && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_DEVICES, name: this.$t('sidebar.admin.devices.label'), active: this.organisationIntegrations.some(i => i.key === 'fieldwiz') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_POLAR_TEAM, name: this.$t('sidebar.admin.polar_team.label'), active: this.organisationIntegrations.some(i => i.key === 'polar-team') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_GPEXE, name: this.$t('sidebar.admin.gpexe.label'), active: this.organisationIntegrations.some(i => i.key === 'gpexe') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_FIELDWIZ, name: this.$t('sidebar.admin.fieldwiz.label'), active: this.organisationIntegrations.some(i => i.key === 'fieldwiz') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_CATAPULT, name: this.$t('sidebar.admin.catapult.label'), active: this.organisationIntegrations.some(i => i.key === 'catapult') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_VALD, name: this.$t('sidebar.admin.vald.label'), active: this.organisationIntegrations.some(i => i.key === 'vald') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_KINEXON, name: this.$t('sidebar.admin.kinexon.label'), active: this.organisationIntegrations.some(i => i.key === 'kinexon') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_COMET, name: this.$t('sidebar.admin.comet.label'), active: this.organisationIntegrations.some(i => i.key === 'comet') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_STATSPORTS, name: this.$t('sidebar.admin.statsports.label'), active: this.organisationIntegrations.some(i => i.key === 'statsports_api') && this.$can('manage-organisation') }] : []),
            ...(!this.hasNoPlayers ? [{ routeName: this.$routeNames.ADMIN_QUESTIONNAIRES, name: this.$t('admin.questionnaires'), active: (this.hasItlModule || this.hasScoutingModule) && this.$can('manage-organisation') }] : []),
            { routeName: this.$routeNames.ADMIN_BILLING, name: this.$t('admin.billing'), active: this.hasBilling && this.$can('manage-organisation') }
          ],
          active: this.isAdmin,
          icon: admin
        }
      ]
    },
    filteredRoutes() {
      return this.routes.filter(route => route.active).map(route => {
        if (route.children) route.children = route.children.filter(child => child.active)
        return route
      })
    },
    isAdmin() {
      return this.$can('manage-organisation') || this.$can('manage-team-players')
    },
    hasItlModule() {
      return this.user.organisation_settings?.has_itl_module || false
    },
    hasGpsModule() {
      return this.user.organisation_settings?.has_gps_module || false
    },
    hasHrModule() {
      return this.user.organisation_settings?.has_heart_rate_module || false
    },
    hasMedicalModule() {
      return this.user.organisation_settings?.has_medical_module || false
    },
    hasDiagnosticsModule() {
      return this.user.organisation_settings?.has_diagnostics_module || false
    },
    hasTrainingBuilderModule() {
      return this.user.organisation_settings?.has_training_builder_module || false
    },
    hasTrainingProgramsModule() {
      return this.user.organisation_settings?.has_training_programs_module || false
    },
    hasDrillModule() {
      return this.user.organisation_settings?.has_drill_module || false
    },
    hasCometIntegration() {
      return (this.user.organisation_settings.integrations || []).some(i => i.key === 'comet')
    },
    hasMembershipModule() {
      return this.user.organisation_settings?.has_membership_module || false
    },
    hasScoutingModule() {
      return this.user.organisation_settings?.has_scouting_module || false
    },
    hasParentsModule() {
      return this.user.organisation_settings?.has_parents_module || false
    },
    organisationIntegrations() {
      return this.user.organisation_settings?.integrations || []
    },
    hasNoPlayers() {
      return this.user.organisation_settings?.has_no_players || false
    },
    teamWithDrill() {
      return ['Football', 'Futsal', 'Handball', 'Basketball', 'Hockey', 'US Football', 'Water Polo', 'Volleyball', 'Badminton', 'Baseball', 'Lacrosse', 'Pickleball', 'Tennis', 'Field Hockey'].includes(this.currentTeam?.sport?.name) || false
    },
    hasBilling() {
      return this.user.has_billing
    },
    hasNoEvents() {
      return this.user.organisation_settings?.has_no_events || false
    },
    hasNoStaff() {
      return this.user.organisation_settings?.has_no_staff || false
    },
    hasDailyActivityModule() {
      return this.user.organisation_settings.has_daily_activity_module || false
    },
    hasEventStats() {
      return this.user.organisation_settings?.has_event_stats || false
    },
    hasMultipleSports() {
      return this.user.organisation_settings?.has_multiple_sports || false
    }
  },
  created() {
    this.fetchTrainingGroups()
  },
  methods: {
    async fetchTrainingGroups() {
      if (!this.hasTrainingBuilderModule) return

      this.trainingGroups.loading = true

      try {
        const result = await TrainingExerciseApiService.getAllGroups()

        this.trainingGroups.data = result.filter(group => {
          return !!group.sport_id && (this.hasMultipleSports || (this.user.sport?.id === group.sport_id))
        })
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_groups.error'),
          color: 'error'
        })

        throw e
      } finally {
        this.trainingGroups.loading = false
      }
    }
  }
}
</script>

<style scoped>
.center-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.list-item-active {
  color: var(--v-primary-base);
  background-color: rgba(188, 41, 28, 0.12);
}

</style>
